import React from 'react';

interface CustomSpinnerProps {
	width?: number;
	height?: number;
	border?: number;
}

export const CustomSpinner: React.FC<CustomSpinnerProps> = ({
	width = 25,
	height = 25,
	border=4,
}) => {
	return (
		<div
			className={`relative flex items-center justify-center w-[${width}px] h-[${height}px] rounded-full`}
		>
			<div
				className={`w-[${width}px] h-[${height}px] border-[${border}px] border-gray-300 border-t-gray-700 rounded-full animate-spin`}
			></div>
		</div>
	);
};
